module.exports = __webpack_public_path__ + "static/img/square.e754ddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/square.png
// module id = FYuE
// module chunks = 1